/**
 * The floating contact button.
 *
 * Both actions are ordinary links and work with this script absent — they are
 * simply always visible then, which is a worse layout but not a broken one.
 * What is added is the collapse, so the corner of every page is one button
 * rather than a stack of them.
 */
class FloatingContact extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-fab-toggle]');
    this.panel = this.querySelector('[data-fab-panel]');
    if (!this.button || !this.panel) return;

    this.onToggle = this.onToggle.bind(this);
    this.onDocClick = this.onDocClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.button.addEventListener('click', this.onToggle);
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onToggle);
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  get isOpen() {
    return this.classList.contains('is-open');
  }

  onToggle() {
    this.classList.toggle('is-open');
    this.panel.hidden = !this.isOpen;
    this.button.setAttribute('aria-expanded', String(this.isOpen));
  }

  onDocClick(event) {
    if (this.isOpen && !this.contains(event.target)) this.onToggle();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.onToggle();
      this.button.focus();
    }
  }
}

customElements.define('floating-contact', FloatingContact);
